document.getElementById("appointment-form").addEventListener("submit", function(event) {
  event.preventDefault();  // Prevent the form from submitting in the traditional way

  // Optionally, display a confirmation message (or handle form submission in other ways)
  document.getElementById("confirmation-message").style.display = "block"; // Show confirmation message

  // After a short delay (to show the confirmation message), redirect to the homepage
  setTimeout(function() {
    window.location.href = '/';  // Redirect to the homepage in Shopify
  }, 2000);  // Redirect after 2 seconds (adjust as needed)
});
